// assets
import IconShieldHalfFilled from '@tabler/icons-react/dist/esm/icons/IconShieldHalfFilled';
import IconFileDescription from '@tabler/icons-react/dist/esm/icons/IconFileDescription';
import IconUsers from '@tabler/icons-react/dist/esm/icons/IconUsers';
import IconPencil from '@tabler/icons-react/dist/esm/icons/IconPencil';
// import IconReportAnalytics from '@tabler/icons-react/dist/esm/icons/IconReportAnalytics';
import IconPhoto from '@tabler/icons-react/dist/esm/icons/IconPhoto';
import IconUserCircle from '@tabler/icons-react/dist/esm/icons/IconUserCircle';
import IconLayoutDashboard from '@tabler/icons-react/dist/esm/icons/IconLayoutDashboard';
import IconClipboardText from '@tabler/icons-react/dist/esm/icons/IconClipboardText';
import IconAddressBook from '@tabler/icons-react/dist/esm/icons/IconAddressBook';
import IconMapPins from '@tabler/icons-react/dist/esm/icons/IconMapPins';
import IconLayersSubtract from '@tabler/icons-react/dist/esm/icons/IconLayersSubtract';
import IconCalendarEvent from '@tabler/icons-react/dist/esm/icons/IconCalendarEvent';
import IconBook2 from '@tabler/icons-react/dist/esm/icons/IconBook2';
import IconUserShare from '@tabler/icons-react/dist/esm/icons/IconUserShare';
import IconAffiliate from '@tabler/icons-react/dist/esm/icons/IconAffiliate';
import IconMailSpark from '@tabler/icons-react/dist/esm/icons/IconMailSpark';
import IconFileInvoice from '@tabler/icons-react/dist/esm/icons/IconFileInvoice';
import IconCirclePercentage from '@tabler/icons-react/dist/esm/icons/IconCirclePercentage';
import IconPackage from '@tabler/icons-react/dist/esm/icons/IconPackage';
import IconSchema from '@tabler/icons-react/dist/esm/icons/IconSchema';

// constant
import { workflowsFeatureFlagEnabled } from 'constants-ts/featureFlags';
import { CORE_PERMISSIONS } from '@a1/shared';

// ==============================|| ADMIN MENU ITEMS ||============================== //

const surveyPages = {
  id: 'surveyPages',
  title: 'Surveys',
  type: 'group',
  children: [
    {
      id: 'survey-backgrounds',
      title: 'Survey Backgrounds',
      type: 'item',
      url: '/admin-manage-survey-backgrounds',
      icon: IconPhoto,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'survey-types',
      entityId: 'surveyTypes',
      title: 'Survey Types',
      type: 'item',
      url: '/manage-survey-types',
      icon: IconPencil,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'surveys',
      entityId: 'surveys',
      title: 'View Surveys',
      type: 'item',
      url: '/view-surveys',
      icon: IconClipboardText,
      breadcrumbs: false,
      minimumPermissions: []
    },
    // {
    //   id: 'manage-survey-reports',
    //   title: 'Reports',
    //   type: 'item',
    //   url: '/manage-survey-reports',
    //   icon: IconReportAnalytics,
    //   breadcrumbs: false,
    //   minimumPermissions: []
    // },
    {
      id: 'survey-communications',
      title: 'Communications',
      type: 'item',
      url: '/manage-communications/survey',
      icon: IconMailSpark,
      breadcrumbs: false,
      minimumPermissions: []
    }
  ]
};

const userPages = {
  id: 'userPages',
  title: 'Users',
  type: 'group',
  children: [
    {
      id: 'manage-admins',
      entityId: 'admins',
      title: 'Administrators',
      type: 'item',
      url: '/manage-admins',
      icon: IconUserCircle,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'manage-managers',
      entityId: 'managers',
      title: 'Managers',
      type: 'item',
      url: '/manage-managers',
      icon: IconFileDescription,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'manage-ext-users',
      entityId: 'externalUsers',
      title: 'External Users',
      type: 'item',
      url: '/manage-ext-users',
      icon: IconUserShare,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'respondents',
      entityId: 'respondents',
      title: 'Respondents',
      type: 'item',
      url: '/respondents',
      icon: IconUserCircle,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'manage-access-roles',
      title: 'Access Roles',
      type: 'item',
      url: '/manage-access-roles',
      icon: IconShieldHalfFilled,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'manage-recipients',
      title: 'Recipients',
      type: 'item',
      url: '/manage-recipients',
      icon: IconAddressBook,
      breadcrumbs: false,
      minimumPermissions: []
    }
  ]
};

const dashboardPages = {
  id: 'dashboardPages',
  title: '',
  type: 'group',
  children: [
    {
      id: 'quickStart',
      title: 'Quick Start',
      type: 'item',
      url: '/quick-start',
      icon: IconLayoutDashboard,
      breadcrumbs: false,
      featureFlag: 'aiFeatures',
      minimumPermissions: [CORE_PERMISSIONS.VIEW_QUICK_START]
    },
    {
      id: 'bookingStats',
      title: 'Booking Dashboard',
      type: 'item',
      url: '/dashboard-booking-stats',
      icon: IconLayoutDashboard,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'surveyStats',
      title: 'Survey Dashboard',
      type: 'item',
      url: '/dashboard-survey-stats',
      icon: IconLayoutDashboard,
      breadcrumbs: false,
      minimumPermissions: []
    }
  ]
};

const bookingPages = {
  id: 'bookingPages',
  title: 'Bookings and Scheduling',
  type: 'group',
  children: [
    {
      id: 'services',
      title: 'Services',
      type: 'item',
      url: '/manage-services',
      icon: IconUsers,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'locations',
      title: 'Locations',
      type: 'item',
      url: '/locations',
      icon: IconMapPins,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'booking-pages',
      title: 'Booking Pages',
      type: 'item',
      url: '/manage-booking-pages',
      icon: IconLayersSubtract,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'bookings',
      title: 'Bookings',
      type: 'item',
      url: '/manage-bookings',
      icon: IconBook2,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'booking-calendar',
      title: 'Calendar',
      type: 'item',
      url: '/manage-booking-calendar',
      icon: IconCalendarEvent,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'booking-communications',
      title: 'Communications',
      type: 'item',
      url: '/manage-communications/booking',
      icon: IconMailSpark,
      breadcrumbs: false,
      minimumPermissions: []
    }
  ]
};

const companyPages = {
  id: 'companies',
  title: 'Companies',
  type: 'group',
  featureFlag: 'companies',
  children: [
    {
      id: 'companies',
      title: 'Companies',
      type: 'item',
      url: '/manage-companies',
      icon: IconAffiliate,
      breadcrumbs: false,
      minimumPermissions: []
    }
  ]
};

const invoicingPages = {
  id: 'invoicingAndPayments',
  title: 'Invoicing and Payments',
  type: 'group',
  featureFlag: 'invoicingAndPayments',
  children: [
    {
      id: 'tax-rates',
      title: 'Tax Rates',
      type: 'item',
      url: '/manage-tax-rates',
      icon: IconCirclePercentage,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'items',
      title: 'Items',
      type: 'item',
      url: '/manage-items',
      icon: IconPackage,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'invoices',
      title: 'Invoices',
      type: 'item',
      url: '/manage-invoices',
      icon: IconFileInvoice,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'contacts',
      title: 'Contacts',
      type: 'item',
      url: '/manage-contacts',
      icon: IconAddressBook,
      breadcrumbs: false,
      minimumPermissions: []
    }
  ]
};

const workflowPages = {
  id: 'workflows-and-automations',
  title: 'Workflows and Automations',
  type: 'group',
  children: [
    {
      id: 'workflows',
      title: 'Workflows',
      type: 'item',
      url: '/workflows',
      icon: IconSchema,
      breadcrumbs: false,
      minimumPermissions: [CORE_PERMISSIONS.READ_WORKFLOWS],
      beta: true
    }
  ]
};

const templatePages = {
  id: 'templates',
  title: 'Templates',
  type: 'group',
  children: [
    {
      id: 'templates',
      title: 'Templates',
      type: 'item',
      url: '/manage-templates',
      icon: IconCirclePercentage,
      breadcrumbs: false,
      minimumPermissions: []
    }
  ]
};

const adminPages = [
  dashboardPages,
  userPages,
  companyPages,
  bookingPages,
  invoicingPages,
  surveyPages,
  ...(workflowsFeatureFlagEnabled ? [workflowPages] : []),
  templatePages
];

export default adminPages;
